// frontend/src/helpers/sourceTictactoeImages.js
export const sourceTictactoeImages = require.context('../assets/images/tictactoe', true);